<!--时间对标 timeBenchmark-->
<template>
  <div class="mytimeBenchmark">
    <div class="con">
      <div class="tree-left">
        <elUnitTree
          @checkFun="mysearch"
          :dataList="virtualDeviceList"
        ></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>应用类型组：</span>
                <el-select
                  v-model="apptypeValue"
                  multiple
                  collapse-tags
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    label="全选"
                    value="全选"
                    @click.native="selectAll"
                  ></el-option>
                  <el-option
                    v-for="item in apptypeGroups"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="input-small mr-20 myinput">
                <span>周期：</span>
                <el-select
                  v-model="nowTimetype"
                  placeholder="请选择"
                  @change="search"
                >
                  <el-option
                    v-for="item in timestype"
                    :key="item.en"
                    :label="item.ch"
                    :value="item.en"
                  ></el-option>
                </el-select>
              </div>
              <div class="input-small mr-20">
                <span>时间一：</span>
                <el-date-picker
                  v-model="firstTime"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div class="input-small">
                <span>时间二：</span>
                <el-date-picker
                  v-model="secondTime"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <el-button
                type="primary"
                plain
                @click="mysearch"
                class="search-btn"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="downloadExcel"
                class="search-btn"
                >导出</el-button
              >
            </div>
          </el-scrollbar>
        </div>
        <div class="mychart" style="width:100%;height:calc(100% - 320px)">
          <vchart style="width:100%;height:100%" ref="vchart"></vchart>
        </div>
        <div class="mytable" style="height:220px">
          <el-table
            :data="nowPage"
            :header-cell-style="{
              'text-align': 'center',
              background: '#F1F4F7',
            }"
            :cell-style="{ 'text-align': 'center' }"
            max-height="200"
            border
          >
            <template slot="empty">
              <span class="noData">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column fixed type="index" width="50"></el-table-column>
            <el-table-column fixed prop="0" label="名称" width="180">
            </el-table-column>
            <el-table-column
              v-for="(item, index) in columns"
              :prop="(index + 1).toString()"
              :label="item.name"
              :key="item.key"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="currentPage"
            :page-sizes="[15, 25, 35, 45, 55]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import vchart from "@/components/module/chart/vchart.vue";
import elUnitTree from "@/components/module/newTree/elDeviceTree.vue";
export default {
  components: {
    vchart,
    elUnitTree,
  },
  props: [],
  data() {
    return {
      nowPage: this.$store.resourcesStore.state.nowPage,
      apptypeGroups: this.$store.resourcesStore.state.apptypeGroups,
      loading: false,
      heights: document.body.clientHeight - 818, //屏幕高度 - 导航栏高度
      date1: undefined,
      nowApptypeGroups: [],
      nowTimetype: "day",
      options: this.$store.resourcesStore.state.options,
      dataList: [], //临时存储查询到的数据
      nowIndex: 0,
      total: 0,
      currentPage: 1,
      currentSize: 15,
      weekList: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      from2name: {},
      apptypeValue: [],
      firstTime: new Date().getTime() - 24 * 60 * 60 * 1000,
      secondTime: new Date().getTime(),
      timestype: [
        {
          ch: "日",
          en: "day",
        },
        {
          ch: "月",
          en: "month",
        },
        {
          ch: "年",
          en: "year",
        },
      ],
      nowVirtualDevice: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    //默认从昨天开始查
    this.date1 = new Date(this.date2.getTime() - 24 * 60 * 60 * 1000);
  },
  mounted() {
    this.apptypeValue = this.nowSelectAppTypeGroupIds;
    debugPage = this;
    this.$refs.vchart.setData(this.options, true);
  },
  destroyed() {},
  computed: {
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    cacheStore() {
      return this.$store.cacheStore;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    datePickerType() {
      switch (this.nowTimetype) {
        case "day":
        case "week":
          return "day";
        case "month":
        case "quarter":
          return "month";
        case "year":
          return "year";
      }
    },
    date2() {
      return this.cacheStore.getters.getNowSelectDate;
    },
    variableTree() {
      if (this.nowVirtualDevice == undefined) {
        return [];
      }
      return this.$store.variableStore.getters.getVariableTree(
        this.nowVirtualDevice.no
      );
    },
    columns() {
      /*{
          name: '变量名'
        }*/
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          //取出每个整点值
          for (var i = 0; i < 24; i++) {
            list.push({
              name: (i < 10 ? "0" : "") + i + ":00",
              key: String(i + 1),
            });
          }
          break;
        case "week":
          for (var i = 0; i < 7; i++) {
            list.push({
              name: this.weekList[i],
              key: String(i + 1),
            });
          }
          break;
        case "month":
          for (var i = 1; i <= 31; i++) {
            list.push({
              name: i + "日",
              key: String(i + 1),
            });
          }
          break;
        case "quarter":
          for (var i = 0; i < 3; i++) {
            list.push({
              name: this.mergeQuarterList[i],
              key: String(i + 1),
            });
          }
          break;
        case "year":
          for (var i = 1; i <= 12; i++) {
            list.push({
              name: i + "月",
              key: String(i),
            });
          }
          break;
      }
      return list;
    },
    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          v2.push(i.fromName); //name != fromName
        });
      });
      return v2;
    },
    allVariableName() {
      //所有的通讯变量名称
      var list = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        var next = this.variableTree[i].next;
        for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
          var item = next[i2];
          this.from2name[item.fromName] = item.name;
          list.push(item.fromName); //fromName
        }
      }
      return list;
    },
    fiflterDataList() {
      //经过过滤的应该显示的数据列表,未合并的
      if (this.dataList.length != 2) {
        return [];
      }
      if (isempty(this.dataList[0]) || isempty(this.dataList[1])) {
        return [];
      }
      var list = [{}, {}];
      this.nowVariableNames.forEach((item) => {
        list[0][item] = this.dataList[0][item];
        list[1][item] = this.dataList[1][item];
      });
      return list;
    },
    mergeDataList() {
      //用于渲染的合并后的数组
      if (isempty(this.fiflterDataList) || this.fiflterDataList.length != 2) {
        return [];
      }
      //合并后的数据列，一个方便解析的数组
      var list1 = this.tranList(this.fiflterDataList[0]);
      var list2 = this.tranList(this.fiflterDataList[1]);
      //两个数组交叉合并,并且加上序号
      var list = [];
      for (var i = 0; i < list1.length; i++) {
        if (this.nowTimetype == "day") {
          list1[i][0] =
            list1[i][0] + "-" + new Date(this.firstTime).formatByDate();
        }

        list.push(list1[i]);
        if (this.nowTimetype == "day") {
          list2[i][0] =
            list2[i][0] + "-" + new Date(this.secondTime).formatByDate();
          list.push(list2[i]);
        }
      }
      return list;
    },
    chartDataList() {
      //图表使用的数据
      var list = [];
      for (var i = 0, len = this.mergeDataList.length; i < len; i++) {
        var l = this.mergeDataList[i];
        var l2 = [l[0]];
        switch (this.nowTimetype) {
          case "day":
            //取出每个整点值
            for (var i2 = 1, len2 = 25; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([i2 - 1, value]);
            }
            break;
          case "week":
            for (var i2 = 1, len2 = 8; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([this.weekList[i2 - 1], value]);
            }
            break;
          case "month":
            for (var i2 = 1, len2 = 32; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([i2 + "日", value]);
            }
            break;
          case "quarter":
            for (var i2 = 1, len2 = 4; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([this.mergeQuarterList[i2 - 1], value]);
            }
            break;
          case "year":
            for (var i2 = 1, len2 = 13; i2 < len2; i2++) {
              //l.length
              var value = l[i2];
              if (isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
                value = undefined;
              }
              l2.push([i2 + "月", value]);
            }
            break;
        }

        list.push(l2);
      }
      return list;
    },
    pageLen() {
      return this.mergeDataList.length < this.currentSize
        ? this.mergeDataList.length
        : this.currentSize;
    },

    getDateText() {
      return (date) => {
        switch (this.nowTimetype) {
          case "day":
            return date.formatByDate("-");
          case "week":
            return date.formatByDate("-");
          case "month":
            return date.formatByMonth("-");
          case "quarter":
            return date.formatByMonth("-");
          case "year":
            return date.getFullYear() + "";
        }
      };
    },
    mergeQuarterList() {
      //混合坐标轴
      /* if((this.date1.getMonth() / 3 | 0) == (this.date2.getMonth() / 3 | 0)) {
          //同一个季度
          return this.getQuarterList(this.date1)
        } else {
          var list1 = this.getQuarterList(this.date1)
          var list2 = this.getQuarterList(this.date2) */
      if (
        ((new Date(this.firstTime).getMonth() / 3) | 0) ==
        ((this.date2.getMonth() / 3) | 0)
      ) {
        //同一个季度
        return this.getQuarterList(new Date(this.firstTime));
      } else {
        var list1 = this.getQuarterList(new Date(this.firstTime));
        var list2 = this.getQuarterList(new Date(this.secondTime));
        var list = [];
        for (var i = 0; i < 3; i++) {
          list.push(list1[i] + "/" + list2[i]);
        }
        return list;
      }
    },
    // nowVirtualDevice () {
    //   console.log("this.$store.deviceStore.state.nowVirtualDevice",this.$store.deviceStore.state.nowVirtualDevice);
    //   return this.$store.deviceStore.state.nowVirtualDevice
    // }
  },
  watch: {
    allVariableName(nv, ov) {},
    chartDataList(nv, ov) {
      //重新渲染
      this.reloadChart(nv);
    },
    nowTimetype(nv, ov) {},
    firstTime() {},
    secondTime() {},
    /* date1(nv, ov) {
       
      },
      date2(nv, ov) {
       
      }, */
    apptypeValue(nv, ov) {
      this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", nv);
      let list = [];
      if (!isempty(nv)) {
        nv.forEach((item) => {
          this.apptypeGroups.forEach((item2) => {
            if (item == item2.id) {
              list.push(item2);
            }
          });
        });
      }
      this.nowApptypeGroups = list;
    },
  },
  methods: {
    getMath(index) {
      if (!index) {
        index = 100;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      var d = Math.floor(Math.random() * (max - min + 1)) + min;
      if (d) {
        return d.toFixed(2) || 0;
      }
      return d || 0;
    },
    mysearch() {
      this.options.series.map((v) => {
        v.data.map((a, i) => {
          v.data[i] = this.getMath(v.data[i]);
        });
      });

      this.$refs.vchart.setData(this.options, true);

      this.nowPage.map((v) => {
        v.map((a, i) => {
          if (i) {
            v[i] = this.getMath(v[i]);
          }
        });
      });
    },

    checkFun(val) {
      this.nowVirtualDevice = val[0];
    },
    downloadExcel() {
      let title = "<thead><tr>";
      title +=
        "<th colspan=6>" + new Date().formatByTime("-") + " 时间对标" + "</th>";
      title += "</tr></thead>";
      let aa = document.getElementsByTagName("thead")[0]; //头部表达
      let bb = document.getElementsByTagName("tbody")[0]; //列表内容
      let table = title + aa.innerHTML + bb.innerHTML;
      exportToExcel(table, "时间对标报告");
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    clickChange(index) {
      this.nowIndex = index - 1;
    },
    prevClick() {
      if (this.nowIndex == 1) {
        this.$message("当前为第一页");
        return;
      }
      this.nowIndex -= 1;
    },
    nextClick() {
      if (
        this.nowIndex == Math.ceil(this.mergeDataList.length / this.pageLen)
      ) {
        this.$message("当前为最后一页");
        return;
      }
      this.nowIndex += 1;
    },
    autoSelectMethod(item, index) {
      if (this.nowVirtualDevice != undefined) {
        return (
          this.nowVirtualDevice.id == item.id &&
          this.nowVirtualDevice.type == item.type
        );
      } else {
        return item.type == "virtualDevice";
      }
    },
    search() {
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          //取出每个整点值
          for (var i = 0; i < 24; i++) {
            list.push((i < 10 ? "0" : "") + i + ":00");
          }
          break;
        case "week":
          for (var i = 0; i < 7; i++) {
            list.push(this.weekList[i]);
          }
          break;
        case "month":
          for (var i = 1; i <= 31; i++) {
            list.push(i + "日");
          }
          break;
        case "quarter":
          for (var i = 0; i < 3; i++) {
            list.push(this.mergeQuarterList[i]);
          }
          break;
        case "year":
          for (var i = 1; i <= 12; i++) {
            list.push(i + "月");
          }
          break;
      }
      this.options.xAxis.data = list;

      this.$refs.vchart.setData(this.options, true);
    },
    tranList(dataObject) {
      //取出数据中的有效数据组织为数组
      var list = [
        [
          "DC输入电压高1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "DC输入电压高2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "DC输入电压高3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "当前年发电量",
          8766.52,
          8766.52,
          8766.52,
          8766.52,
          8766.52,
          8766.52,
          8766.52,
          8766.52,
          8768.12,
          8770.12,
          8776.74,
          8795.12,
          8818.46,
          8839.66,
          8860.6,
          8880.12,
          8894.6,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "当前日发电量",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.14,
          1.76,
          4.3,
          10.8,
          28.98,
          51.8,
          73.14,
          94.08,
          113.6,
          128.08,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "当前月发电量",
          481.34,
          481.34,
          481.34,
          481.34,
          481.34,
          481.34,
          481.34,
          481.34,
          482.94,
          484.94,
          491.56,
          509.94,
          533.28,
          554.48,
          575.42,
          594.94,
          609.42,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "接地异常",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "残余电流异常1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "残余电流异常2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "温度过高1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "温度过高2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "温度过高3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "温度过高4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常10",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常11",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常12",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常13",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常14",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常15",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常16",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常17",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常5",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常6",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常7",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常8",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网电压异常9",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网频率异常1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网频率异常2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网频率异常3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网频率异常4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "直流电路异常1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "直流电路异常2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "直流电路异常3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "直流电路异常4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障5",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障6",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障7",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障8",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "系统故障9",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串1反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串1反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串2反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串2反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串3反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串3反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串4反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串4反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串5反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串5反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串6反向",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "组串6反向1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "绝缘阻抗低",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "设备效率",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          95.13,
          97.56,
          97.62,
          98.28,
          98.55,
          98.57,
          98.07,
          98.04,
          98.58,
          98.6,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常1",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常2",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常3",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常4",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常5",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "逆变电路异常6",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV1输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.1,
          0.7,
          1.1,
          3.1,
          6.1,
          7.4,
          6.2,
          6.3,
          5.2,
          3.3,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV4输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2,
          0.8,
          1.1,
          3,
          6.1,
          7.3,
          6.3,
          6.2,
          5.2,
          3.4,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV5输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.1,
          0.7,
          1,
          2.8,
          5.8,
          6.9,
          6,
          5.8,
          4.8,
          3.1,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV6输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2,
          0.8,
          1.1,
          2.9,
          6,
          7,
          6,
          6,
          5,
          3.2,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网A相电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          4,
          5.6,
          15.1,
          29.5,
          34.1,
          29.1,
          28.9,
          24.6,
          16.5,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV2输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.2,
          0.8,
          1.1,
          3,
          5.9,
          7,
          6,
          6,
          5,
          3.2,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网B相电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.9,
          3.9,
          5.6,
          15.2,
          29.4,
          34,
          29.4,
          29,
          24.6,
          16.5,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV3输入电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.1,
          0.8,
          1,
          2.9,
          6.1,
          7.4,
          6.2,
          6.1,
          5,
          3.2,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网C相电流",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.9,
          3.9,
          5.6,
          15.2,
          29.3,
          34.2,
          29.5,
          29,
          24.7,
          16.6,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV1输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          569.6,
          617,
          629.1,
          623.1,
          609,
          585,
          597,
          591,
          603,
          621,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV4输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          567.9,
          597.3,
          629.4,
          623.4,
          579,
          567,
          573,
          573,
          585,
          603,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV5输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          544.8,
          616.2,
          628.8,
          622.9,
          585,
          573,
          585,
          579,
          591,
          609,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV6输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          544.8,
          616.2,
          628.8,
          622.9,
          585,
          573,
          585,
          579,
          591,
          609,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网A相电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          231.9,
          237,
          236,
          236.3,
          237,
          238,
          237,
          235,
          235,
          234.1,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV2输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          569.6,
          617,
          629.1,
          623.1,
          609,
          585,
          597,
          591,
          603,
          621,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网B相电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          233.1,
          237.1,
          235.4,
          236.1,
          238.2,
          239.1,
          238.5,
          236.1,
          235.1,
          234.1,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "PV3输入电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          567.9,
          597.3,
          629.4,
          623.4,
          579,
          567,
          573,
          573,
          585,
          603,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网C相电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          233.4,
          238,
          236,
          236.4,
          238,
          239.5,
          239.4,
          236.2,
          237.1,
          235.8,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "总发电量",
          328542.19,
          328542.19,
          328542.19,
          328542.19,
          328542.19,
          328542.19,
          328542.19,
          328542.19,
          328543.84,
          328545.84,
          328552.5,
          328571.06,
          328593.34,
          328614.56,
          328636.5,
          328655,
          328670.44,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "有功功率",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.62,
          2.86,
          4.07,
          10.76,
          21.2,
          24.46,
          21.1,
          20.67,
          17.25,
          11.72,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "当天峰值有功功率",
          22.38,
          22.38,
          22.38,
          22.38,
          22.38,
          22.38,
          22.38,
          0.62,
          2.83,
          4.07,
          10.83,
          22.97,
          24.09,
          24.75,
          24.75,
          24.75,
          24.75,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "输入总功率",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.64,
          2.91,
          4.17,
          10.97,
          21.51,
          24.94,
          21.4,
          21.08,
          17.56,
          11.91,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网频率",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          49.96,
          50.04,
          50.02,
          50.02,
          49.98,
          50.03,
          50.02,
          50.01,
          50.03,
          49.97,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "机内温度",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          25.1,
          27.9,
          30.5,
          34.6,
          53.7,
          54.4,
          55.9,
          57.4,
          54.2,
          49,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "功率因数",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          1,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "无功功率",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0.01,
          0,
          0,
          -0.01,
          0,
          0,
          0,
          0.01,
          -0.01,
          0,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网AB线电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          402.4,
          411,
          407,
          409.4,
          411,
          411.9,
          412,
          407.3,
          407.1,
          406,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网CA线电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          404,
          413,
          409.1,
          410.1,
          412,
          414,
          413.1,
          408,
          410.2,
          409,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        [
          "电网BC线电压",
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          405.1,
          414.1,
          411.1,
          413.4,
          415.1,
          417,
          415.1,
          410.9,
          412.1,
          410.1,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      ];

      return list;
    },
    getAvg(data) {
      //计算出合理值
      if (!isnull(data.avg)) {
        return data.avg;
      }
      if (!isempty(data.data)) {
        var count = 0;
        var sum = data.data.reduce((a, b) => {
          console.log(a, b, "ababbabab");
          if (isnull(b)) {
            return a;
          }
          count++;
          return a + b;
        });
        if (count != 0) {
          return cutDigital(sum / count);
        }
      }
      return undefined;
    },
    tranDayList(key, item) {
      //每天的数据，取整点值
      var name = this.from2name[key] ? this.from2name[key] : key;
      var list = [name.subByFirstChar(".")];
      if (isempty(item.data)) {
        return list;
      }
      for (var i = 0, len = item.data.length; i < len; i += 12) {
        var temp = item.data[i];
        if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
          temp = undefined;
        }
        list.push(temp);
      }
      return list;
    },
    tranWeekList(key, dataList) {
      //每周的数据，取平均值
      // var list = [key.subByFirstChar('.')]
      var name = this.from2name[key] ? this.from2name[key] : key;
      var list = [name.subByFirstChar(".")];
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }
      return list;
    },
    tranMonthList(key, item) {
      //每周的数据，取平均值
      // var list = [key.subByFirstChar('.')]
      var name = this.from2name[key] ? this.from2name[key] : key;
      var list = [name.subByFirstChar(".")];
      if (!isempty(item.data)) {
        var res = item.data.map((i) => {
          if (isNaN(parseFloat(i)) || isnull(parseFloat(i))) {
            return undefined;
          } else {
            return i;
          }
        });
        list.addAll(res);
      }
      return list;
    },
    tranQuarterList(key, dataList) {
      //每周的数据，取平均值
      var name = this.from2name[key] ? this.from2name[key] : key;
      var list = [name.subByFirstChar(".")];
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }
      return list;
    },
    tranYearList(key, dataList) {
      console.log(key, dataList, 333);
      //每周的数据，取平均值
      var name = this.from2name[key] ? this.from2name[key] : key;
      console.log(name, "name");
      var list = [name.subByFirstChar(".")];
      console.log(list, "list");
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }

      return list;
    },
    reloadChart(list) {
      var selected = {};
      var legend = [];
      var seriesList = [];
      for (var i = 0, len = list.length; i < len; i++) {
        var item = list[i];
        var name = item.shift();
        seriesList.push({
          name: name,
          type: "bar",
          smooth: true,
          symbol: "emptyCircle",
          markPoint: {
            data: [
              {
                name: "最大值",
                type: "max",
              },
            ],
          },
          sampling: "average",
          data: item,
        });
        selected[name] = i < 12 ? true : false;
        legend.push({
          name: name,
          icon: "roundRect",
        });
      }
      this.options.series = seriesList;
      this.options.legend.data = legend;
      this.options.legend.selected = selected;

      // this.options.title.text=this.nowVirtualDevice.label+"-时间对标曲线"
      this.options.title.text = "";
      this.$refs.vchart.setData(this.options, true);
    },
    getQuarterList(date) {
      switch ((date.getMonth() / 3) | 0) {
        case 0:
          return ["一月", "二月", "三月"];
        case 1:
          return ["四月", "五月", "六月"];
        case 2:
          return ["七月", "八月", "九月"];
        case 3:
          return ["十月", "十一月", "十二月"];
      }
    },
    //分页功能
    handleSizeChange(val) {
      this.currentSize = val;
    },
    handleCurrentChange(val) {
      this.nowIndex = val - 1;
    },
  },
};
</script>

<style scoped lang="scss">
.mytimeBenchmark {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .search-input-btn {
      width: 100%;
      height: 36px;

      .my-search-i {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button + .el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
    }
  }
}
</style>
